module.exports = __webpack_public_path__ + "img/flux-kontext-3.747b8838.webp";